import React from 'react';
import { Award, ArrowRight } from 'lucide-react';

const Hero = ({ handleNavClick }) => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge">
            <Award size={16} />
            <span>Free Estimates</span>
          </div>
          <div className="hero-badge">
            <Award size={16} />
            <span>6 Year Workmanship Warranty</span>
          </div>
          <h1>Bartlett Enterprises</h1>
          <p>Professional roofing, siding, windows, general carpentry, plowing, and snow removal services with unmatched quality and reliability.</p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => handleNavClick('contact')}>
              Get A Quote <ArrowRight size={20} />
            </button>
            <button className="btn-secondary" onClick={() => handleNavClick('services')}>
              View Services <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;